import type { Supabase } from '~/types/supabase-client';
import TableService from './table.service';
import type { DbResultOk } from '~/types/database-helpers';

export class TeamsService extends TableService<'teams'> {
  constructor(supabase: Supabase) {
    super(supabase, 'teams', {
      pk: 'id',
      defaultSort: { field: 'id', ascending: false, nullsFirst: true },
    });
  }

  public async getTeamDetails(id: string) {
    try {
      const teamDetailsQuery = this.supabase
        .from('teams')
        .select(
          `
            *,
            players (
              *,
              source:source_id (source)
            )
          `
        )
        .eq('id', id);

      type TeamDetails = DbResultOk<typeof teamDetailsQuery>;
      const { data, error } = await teamDetailsQuery;
      if (error) throw error;
      return { data: data as TeamDetails, error: null };
    } catch (error: any) {
      console.error(error);
      throw createError({
        statusCode: 500,
        statusMessage: error.message,
      });
    }
  }
}
